import React, { useState, useRef } from 'react'
import './index.scss'
import { Button, Tabs, Card, Badge, Icon, Modal } from 'antd-mobile'
import bottomLeft from "../../assets/tips/bottom_left.png"
import topRight from "../../assets/tips/top_right.png"
const ProxyDriving = () => {
  const [modal1, setModal1] = useState(false)
  const animateRef = useRef(null)
  const [state, setState] = useState({ num: 5 })
  const [list, setList] = useState([
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
  ])
  const tabs = [
    { title: <Badge text={'3'}>新任务</Badge> },
    { title: <Badge text={'2'}>任务中</Badge> },
    { title: <Badge >已完成</Badge> },
  ];

  const animationendFn = (obj) => {
    // do something
    setState({
      num: obj.num > 1 ? obj.num - 1 : 1
    })
    obj.num = obj.num > 1 ? obj.num - 1 : 1
    animateRef.current.classList.remove('animate__animated', 'animate__fadeOut', 'animate__delay-1s')
    if (obj.num !== 1) {
      setTimeout(() => {
        animateRef.current.classList.add('animate__animated', 'animate__fadeOut', 'animate__delay-1s')
      })
    }else {
      setTimeout(()=>setModal1(false),1000)
    }


  }

  const openTips = () => {
    setModal1(true)
    setTimeout(() => {
      animateRef.current.classList.add('animate__animated', 'animate__fadeOut', 'animate__delay-1s')
      animateRef.current.addEventListener('animationend', () => animationendFn(state));

    })

  }
  return (
    <div className='proxy_driving'>
      <Modal
        visible={modal1}
        transparent
        maskClosable={false}
        className="proxy_driving_tips"
      >
        <div className='right_icon'><img src={topRight}></img></div>
        <div className='left_icon'><img src={bottomLeft}></img></div>
        <div className='r1_box' ref={animateRef}>
          <div className='r2_box'>{state.num}</div>
        </div>
        <div className='tips_title'>抢单中</div>
        <div className='tips_text'>正在为您抢单</div>
      </Modal>
      <Tabs tabs={tabs}
        initialPage={1}
        onChange={(tab, index) => { console.log('onChange', index, tab); }}
        onTabClick={(tab, index) => { console.log('onTabClick', index, tab); }}
      >
        <div className='rushBill'>
          {list.map(item => <div className='card_item'>
            <Card>
              <Card.Body>
                <div className='top_tips'>
                  <div className='time'>
                    <i className='iconfont icon-time'></i>
                    <span>11-24 13:15</span>
                  </div>
                  <div className='r_tips'>可抢单<Icon type="right" /> </div>
                </div>

                {/* 地址 */}
                <div>
                  <div className="travel">
                    <div className="tip">
                      <div className="icon startIcon">起</div>
                      <span>12km</span>
                    </div>
                    <div className='address'>
                      <p className="addressTitle">光明大厦（未来路）</p>
                      <p>金水区与未来路交叉口西北角</p>
                    </div>
                    {/* <div>
                    <i className='iconfont icon-dianji'></i>
                  </div> */}
                  </div>
                  <div className='travel'>
                    <div className="tip">
                      <div className="icon endIcon">终</div>
                      <span>12km</span>
                    </div>
                    <div className='address'>
                      <p className="addressTitle">光明国际（光明路）</p>
                      <p>金水区与未来路交叉口西北角</p>
                    </div>
                    <div className="price">
                      <b>
                        <span>￥</span>
                        50.00
                      </b>
                    </div>
                  </div>
                </div>
                <hr></hr>
                {/* 订单价格 */}
                {/* <div>
                <div className="price">
                  <p className='title'>订单价格</p>
                  <b>
                    <span>￥</span>
                    50.00
                  </b>
                </div>
              </div> */}
                <Button className='btn' variant="contained" type="warning" onClick={openTips}>抢单</Button>
              </Card.Body>
            </Card>
          </div>)}
        </div>
      </Tabs>
    </div>
  )
}
export default ProxyDriving